import React from 'react'
import Modal from 'react-modal'
import './Modal.sass'

class ModalContainer extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showModal: props.showModal,
      customStyles: {},
      portalClassName: `${props.modalType} ${props.screenType}`,
      overlayClassName: props.modalType,
      modalContent: props.modalContent,
      fullContent: props.fullContent
    }
  }

  componentDidUpdate (prevProps) {
    if (prevProps.showModal !== this.props.showModal) {
      this.updateState('showModal', this.props.showModal)
    }
  }

  updateState (key, val) {
    this.setState({ [key]: val })
  }

  canSetModal () {
    return process.env.NODE_ENV !== 'test' && !process.env.STORYBOOK
  }
  
  render () {
    if (this.canSetModal()) Modal.setAppElement('#appModalContainer')
    return (
      <div style={{ zIndex: '9999' }}>
        <Modal
          isOpen={this.state.showModal}
          style={this.state.customStyles}
          portalClassName={`ReactModalPortal ${this.props.modalType} ${this.state.fullContent ? 'full-content' : ''}`}
        >
          {this.state.modalContent}
        </Modal>
      </div>
    )
  }
}
export default ModalContainer
